<template>
    <div class="container">
        <div class="welcome-box">
            <h2>{{ $t('welcome') }} {{ form.name }}</h2>
            <p>{{ $t('YOU ARE A MEMBER') }}</p>
            <h2>{{ $t('bliss store') }}</h2>
        </div>

        <!-- cards -->
        <div class="dashboard">
            <h3 class="title-header-dashboard"> {{ $t('dashboard') }}</h3>

            <div class="row">
                <!--  -->
                <div class="col-lg-4">
                    <!--  -->
                    <router-link
                        class="list-group-item list-group-item-action d-flex align-items-center justify-content-between card_dashboard"
                        :to="{
                            name: 'myOrders',
                            params: { storeName: this.$store.storeName, lang: $i18n.locale },
                        }" :title="$t('myOrders')">
                        <p class="text-black m-0">
                            {{ $t('myOrders') }}
                        </p>
                        <span class="badge text-bg-secondary rounded-pill count_dashboard"
                            data-placeholder_count="quotation_count">0</span>
                    </router-link>
                    <!--  -->
                </div>
                <!--  -->
                <div class="col-lg-4">
                    <!--  -->
                    <router-link
                        class="list-group-item list-group-item-action d-flex align-items-center justify-content-between card_dashboard"
                        :to="{
                            name: 'favourites',
                            params: { storeName: this.$store.storeName, lang: $i18n.locale },
                        }" :title="$t('favourites')">
                        <p class="text-black m-0">
                            {{ $t('favourites') }}
                        </p>
                        <span class="badge text-bg-secondary rounded-pill count_dashboard"
                            data-placeholder_count="quotation_count">0</span>
                    </router-link>
                    <!--  -->
                </div>
                <!--  -->
                <div class="col-lg-4">
                    <!--  -->
                    <router-link
                        class="list-group-item list-group-item-action d-flex align-items-center justify-content-between card_dashboard"
                        :to="{
                            name: 'notifications',
                            params: { storeName: this.$store.storeName, lang: $i18n.locale },
                        }" :title="$t('notifications')">
                        <p class="text-black m-0">
                            {{ $t('notifications') }}
                        </p>
                        <span class="badge text-bg-secondary rounded-pill count_dashboard"
                            data-placeholder_count="quotation_count">0</span>
                    </router-link>
                    <!--  -->
                </div>
                <!--  -->
            </div>

        </div>
        <!-- end cards -->
        <div class="details">
            <h3>{{ $t('details') }}</h3>
            <div class="details_profile">
                <div class="profile_div">
                    <span class="label">{{ $t('name') }}:</span>
                    <div class="d-block ps-xl-2">
                        <i class="fa fa-user"></i>
                        {{ form.name }}
                    </div>

                </div>
                <div class="profile_div">
                    <span class="label">{{ $t('address') }}:</span>
                    <div class="d-block ps-xl-2">

                        <p v-if="DBitems.length != 0" v-for="(item, index) in DBitems" :key="index">
                            <i class="fa fa-map-marker"></i> {{ item.title }} ,{{ item.description }}

                        </p>

                    </div>

                </div>

                <div class="profile_div">
                    <span class="label">{{ $t('email') }}:</span>
                    <div class="d-block ps-xl-2">
                        <i class="fa fa-envelope"></i>
                        {{ form.email }}
                    </div>

                </div>
            </div>
        </div>

        <!--  -->
        <div class="account">
            <h3 class="title-header-dashboard"> {{ $t('account') }}</h3>
            <hr>
            <router-link :to="{
            name: 'change_password',
            params: { storeName: this.$store.storeName, lang: $store.state.routeLang },
          }"
          ><i class="fa fa-pencil mx-1"></i>  {{ $t('edit security setting') }}</router-link>
        </div>
        <!--  -->
    </div>
</template>

<script>

import Form from "vform";
import CodeInput from "vue-verification-code-input";

import Vodal from "vodal";

import "vodal/common.css";
import "vodal/slide-down.css";
import "vodal/flip.css";
import "vodal/slide-left.css";
import { HalfCircleSpinner, HollowDotsSpinner, CirclesToRhombusesSpinner } from "epic-spinners";

export default {
    components: {
        Vodal,
        CodeInput,
        HalfCircleSpinner,
        HollowDotsSpinner,
        CirclesToRhombusesSpinner

    },
    data: function () {
        return {
            //DBitems: null,
            forgetVodal: false,
            codeVodal: false,
            newPassVodal: false,
            DBitems: null,
            errorMessageVodal: "",
            passemail: "",
            Newpassword: null,
            checkcomplete: false,
            finalcode: null,
            phone: null,
            errorMessage: "",
            form: new Form({
                email: null,
                name: null,
                phone: null,
            }),
            show: false,
            show2: false,
        };
    },

    created() {
        if (this.$route.params.lang && this.$route.params.lang != this.$i18n.locale) {
            this.$i18n.locale = this.$route.params.lang; this.$store.state.UnitPrice = this.$store.state.unitAR
            if (this.$i18n.locale == 'en') {
                document.documentElement.setAttribute("dir", "ltr");
                let h = document.querySelector('body');
            }
        }

        this.axios
            .get(
                this.$store.state.base_api_url + this.$store.storeName + "/profile",
                {
                    headers: {
                        "Accept-Language": this.$i18n.locale,
                        Authorization:
                            "Bearer " + this.$localStorage.get(this.$store.storeName)
                    }
                }
            )
            .then(response => {
                this.form.email = response.data.data.email;
                this.form.name = response.data.data.name;
                this.phone = response.data.data.phone.substr(4);
                console.log('phone ' + this.phone);
                this.$localStorage.set(
                    this.$store.user_phone,
                    data.data.phone);
                console.log('******* ', response.data.data)
            })
            .catch(error => {

            });

        // 

        this.axios
            .get(
                this.$store.state.base_api_url + this.$store.storeName + "/addresses",
                {
                    headers: {
                        "Accept-Language": this.$i18n.locale,
                        Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName)
                    }
                }
            )
            .then(response => {
                this.DBitems = response.data.data.addresses.addresses;
                console.log('**** addressess', this.DBitems);
            })
            .then((this.loading = false))
            .catch(error => {
                if (error.response.status == "401") {
                    this.$localStorage.remove(this.$store.storeName);
                    window.location.href = "/";

                }
            });
        //   

        if (this.$i18n.locale == 'ar') {
            document.title = this.$store.state.title_ar;
            document.getElementById("description_meta").content = this.$store.state.description_ar;
            document.getElementById("keywords_meta").content = this.$store.state.keyword_ar;
        }
        else {
            document.title = this.$store.state.title_en;
            document.getElementById("description_meta").content = this.$store.state.description_en;
            document.getElementById("keywords_meta").content = this.$store.state.keyword_en;
        }
    },
    methods: {

        async submitInfo() {
            this.form.phone = this.$store.state.country_code + this.phone;

            const response = await this.axios
                .post(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/profile/update",
                    {
                        email: this.form.email,
                        name: this.form.name,
                        phone: this.form.phone
                    },
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization:
                                "Bearer " + this.$localStorage.get(this.$store.storeName)
                        }
                    }
                )
                .then(response => {
                    if (response.data.code == "1") {
                        this.errorMessage = response.data.message;
                        setTimeout(() => {
                            this.errorMessage = "";
                        }, 3000);
                    } else if (response.data.code == "-1") {
                        this.errorMessage = response.data.message;
                        setTimeout(() => {
                            this.errorMessage = "";
                        }, 3000);
                    }
                    if (response.data.error) {
                        this.errorMessage = response.data.error;
                        setTimeout(() => {
                            this.errorMessage = "";
                        }, 3000);
                    }
                })
                .catch(error => {
                    if (error.response.status == "401") {
                        this.$localStorage.remove(this.$store.storeName);
                        window.location.href = "/";
                    }
                });
        },

    },
    watch: {
        langchange() {
            this.axios
                .get(
                    this.$store.state.base_api_url + this.$store.storeName + "/profile",
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization:
                                "Bearer " + this.$localStorage.get(this.$store.storeName)
                        }
                    }
                )
                .then(response => {
                    this.form.email = response.data.data.email;
                    this.form.name = response.data.data.name;
                    this.phone = response.data.data.phone.substr(4);
                    console.log('phone ' + this.phone);
                    //console.log(this.form)
                })
                .catch(error => {

                });

            this.axios
                .get(
                    this.$store.state.base_api_url + this.$store.storeName + "/addresses",
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName)
                        }
                    }
                )
                .then(response => {
                    this.DBitems = response.data.data.addresses.addresses;
                    console.log('**** addressess', this.DBitems);
                })
                .then((this.loading = false))
                .catch(error => {
                    if (error.response.status == "401") {
                        this.$localStorage.remove(this.$store.storeName);
                        window.location.href = "/";

                    }
                });
        }
    }
};
</script>